import { render, staticRenderFns } from "./InputFile.vue?vue&type=template&id=38adcd7c&"
import script from "./InputFile.vue?vue&type=script&lang=js&"
export * from "./InputFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports